module.exports = __webpack_public_path__ + "img/pole_purchase_img-mobile.22304037.webp";